import { ASSETS_VIEWS } from './AssetsViewToggle';
import { AssetLayout } from './[Asset]/[Asset].layout';
import './translations';
import { Stack } from '@mui/material';
import { Breadcrumb } from 'components/layout/Breadcrumb';
import { breadcrumbTranslation } from 'components/layout/Breadcrumb/utils';
import { AssetBreadcrumb } from 'components/layout/DynamicBreadcrumbs/AssetBreadcrumb';
import { SocketProvider } from 'contexts/SocketContext';
import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { ASSETS_CACHE_KEY } from 'services/queryKeys';
import { DEVICE_TYPE_IDS } from 'utils/constants';

const AssetsLayout = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  function onRowClick(params) {
    if (params.row.deviceTypeId === DEVICE_TYPE_IDS.REPORTING_ONLY_BATTERY) {
      return navigate(`${params.row.externalIdentifier}/reports`);
    }
    return navigate(`${params.row.externalIdentifier}`);
  }

  function onMarkerContentClick(externalIdentifier) {
    return navigate(`${externalIdentifier}`);
  }

  const isOverviewRoute = location.pathname === ASSETS_VIEWS.LIST || location.pathname === ASSETS_VIEWS.MAP;

  const { data: units } = useAxiosQuery(ASSETS_CACHE_KEY(), '/greener-units/');

  return (
    <>
      <SocketProvider>
        <Helmet>
          <title>{t('navigation.units')}</title>
        </Helmet>
        <Stack spacing={0}>
          {isOverviewRoute && <Breadcrumb />}
          <Outlet context={{ units, onMarkerContentClick, onRowClick }} />
        </Stack>
      </SocketProvider>
    </>
  );
};

export const assetsOverviewRoutes = [
  {
    path: 'assets',
    breadcrumb: breadcrumbTranslation('assets'),
    element: <AssetsLayout />,
    children: [
      {
        index: true,
        lazy: () => import('pages/Assets'),
      },
      {
        path: 'location',
        breadcrumb: breadcrumbTranslation('assets-locations'),
        lazy: () => import('pages/Assets/AssetLocation'),
      },
    ],
  },
];

export const assetsRoutes = [
  {
    path: 'assets',
    breadcrumb: breadcrumbTranslation('assets'),
    element: <AssetsLayout />,
    children: [
      {
        path: ':unitExternalIdentifier',
        breadcrumb: AssetBreadcrumb,
        element: <AssetLayout />,
        children: [
          {
            index: true,
            lazy: () => import('pages/Assets/[Asset]'),
          },
          {
            path: 'basic-graphs',
            breadcrumb: breadcrumbTranslation('assets-basic-graphs'),
            lazy: () => import('pages/Assets/[Asset]/BasicGraphs'),
          },
          {
            path: 'advanced-graphs',
            breadcrumb: breadcrumbTranslation('assets-advanced-graphs'),
            lazy: () => import('pages/Assets/[Asset]/AdvancedGraphs'),
          },
          {
            path: 'reports',
            breadcrumb: breadcrumbTranslation('assets-reports'),
            lazy: () => import('pages/Assets/[Asset]/AssetReports'),
          },
          {
            path: 'reports/create-report',
            breadcrumb: breadcrumbTranslation('assets-create-report'),
            lazy: () => import('pages/Assets/[Asset]/AssetReports/CreateReport'),
          },
        ],
      },
    ],
  },
];
